import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck } from 'lucide-react';
export function GuaranteeSection() {
  return <section id="guarantee" className="py-16 bg-[#C5A55A] text-[#1B2E1B]" data-id="element-178">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-179">
        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="flex flex-col items-center" data-id="element-180">
          <ShieldCheck className="w-20 h-20 mb-6 text-[#1B2E1B]" data-id="element-181" />
          <h2 className="text-3xl md:text-4xl font-extrabold mb-6 tracking-tight" data-id="element-182">
            OUR IRONCLAD GUARANTEE
          </h2>
          <div className="bg-white/20 p-8 rounded-2xl backdrop-blur-sm border border-[#1B2E1B]/10 shadow-lg" data-id="element-183">
            <p className="text-xl md:text-2xl font-bold mb-4" data-id="element-184">
              If you're not 100% satisfied with our work...
            </p>
            <p className="text-lg md:text-xl font-medium" data-id="element-185">
              We come back and do it again. No charge. No questions asked.
            </p>
            <p className="mt-6 text-[#1B2E1B]/80 italic font-medium" data-id="element-186">
              That's how confident we are in the quality of our team.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}